import React from "react";
import { useSelector } from "react-redux";
import { selectDarkMode } from "../../../../app/store/slices/uiSlice";
import Tooltip from "../Tooltip";

export default function FormButtons({
  onCancel,
  onSubmit,
  cancelLabel = "Cancel",
  submitLabel = "Submit",
  mode = "add",
  isSubmitting = false,
  className = "",
  // Tab navigation props
  hasMultipleTabs = false,
  isFirstTab = false,
  isLastTab = false,
  onNext = null,
  onPrevious = null,
  // Disable Next button with tooltip
  disableNext = false,
  disableNextTooltip = null
}) {
  const darkMode = useSelector(selectDarkMode);

  const cancelBtnClass = `border rounded-xl font-base font-semibold px-10 py-3 transition-colors ${
    darkMode
      ? 'border-gray-600 text-gray-300 hover:bg-gray-700'
      : 'border-[#F0EFEF] text-[#232526] hover:bg-gray-50'
  }`;

  const submitBtnClass = "bg-[linear-gradient(180deg,#4A9CFF_0%,#4057FE_100%)] px-10 py-3 rounded-xl text-white font-base font-semibold hover:opacity-90 transition-opacity disabled:opacity-50 disabled:cursor-not-allowed";

  // If there are multiple tabs, show tab navigation buttons
  if (hasMultipleTabs && mode !== "view") {
    return (
      <div className={`flex justify-center gap-4 pt-5 sm:pt-9 flex-col sm:flex-row ${className}`}>
        {/* First tab: Cancel & Next */}
        {isFirstTab && (
          <>
            <button type="button" onClick={onCancel} className={cancelBtnClass}>
              {cancelLabel}
            </button>
            <button
              type="button"
              onClick={onNext}
              disabled={isSubmitting || disableNext}
              className={submitBtnClass}
            >
              {isSubmitting ? "Processing..." : "Next"}
            </button>
          </>
        )}

        {/* Middle tabs: Previous & Next */}
        {!isFirstTab && !isLastTab && (
          <>
            <button type="button" onClick={onPrevious} className={cancelBtnClass}>
              Previous
            </button>
            {disableNext && disableNextTooltip ? (
              <Tooltip content={disableNextTooltip} position="top">
                <button
                  type="button"
                  disabled={true}
                  className={`${submitBtnClass} opacity-50 cursor-not-allowed`}
                >
                  Next
                </button>
              </Tooltip>
            ) : (
              <button
                type="button"
                onClick={onNext}
                disabled={isSubmitting || disableNext}
                className={submitBtnClass}
              >
                {isSubmitting ? "Processing..." : "Next"}
              </button>
            )}
          </>
        )}

        {/* Last tab: Previous & Submit */}
        {isLastTab && (
          <>
            <button type="button" onClick={onPrevious} className={cancelBtnClass}>
              Previous
            </button>
            <button type="button" onClick={onNext || onSubmit} disabled={isSubmitting} className={submitBtnClass}>
              {isSubmitting ? "Submitting..." : submitLabel}
            </button>
          </>
        )}
      </div>
    );
  }

  // Default behavior for single-page forms
  return (
    <div className={`flex justify-center gap-4 pt-5 sm:pt-9 flex-col sm:flex-row ${className}`}>
      <button type="button" onClick={onCancel} className={cancelBtnClass}>
        {mode === "view" ? "Close" : cancelLabel}
      </button>

      {mode !== "view" && (
        <button type="submit" onClick={onSubmit} disabled={isSubmitting} className={submitBtnClass}>
          {isSubmitting ? "Submitting..." : submitLabel}
        </button>
      )}
    </div>
  );
}
